import shopifyDawnGenericDefaults from '../shopify-dawn-generic/config.js';

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyDawnGenericDefaults,
  Widgets: [
    ...shopifyDawnGenericDefaults.Widgets.filter(
      (w) => !['HomeVehicleWidget', 'HeaderVehicleWidget', 'SearchVehicleWidget'].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      columnBreakpoint: 700,
    },
  ],
};
